/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unknownerror1Inputs */

const en_unknownerror1 = /** @type {(inputs: Unknownerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown error`)
};

const de_unknownerror1 = /** @type {(inputs: Unknownerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Fehler`)
};

/**
* | output |
* | --- |
* | "Unknown error" |
*
* @param {Unknownerror1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unknownerror1 = /** @type {((inputs?: Unknownerror1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unknownerror1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unknownerror1(inputs)
	return de_unknownerror1(inputs)
});
export { unknownerror1 as "unknownError" }